export const routeNames = {
  CONSULTATIONS: 'consultations',
  JOIN_CONSULTATION: 'join-consultation',
  SCHEDULED_CALL: 'scheduled-call',
  PATIENT_DETAILS: 'patient-details',
  SCHEDULED_CONSULTATION_PATIENT_DETAILS: 'scheduled-consultation-patient-details',
  PATIENT_DETAILS_LIVE_DATA: 'patient-details-live-data',
  USER_PROFILE: 'user-profile',
  ADD_PATIENT: 'add-patient',
  EDIT_PATIENT: 'edit-patient',
  NEW_CONSULTATION: 'new-consultation',
  CREATE_WARD_ROUND: 'create-ward-round',
  CREATE_CASE_CONFERENCE: 'create-case-conference',
  CREATE_PATIENT_PRESENTATION: 'create-patient-presentation',
  CREATE_URGENT_CONSULTATION: 'create-urgent-consultation',
  CREATE_ROUTINE_CONSULTATION: 'create-routine-consultation',
  CONSULTATION_DETAILS: 'consultation-details',
  LOGOUT_HANDOVER: 'logout-handover',
  WRITE_DIRECT_CONSULTATION_REPORT: 'write-direct-consultation-report',
  WRITE_SCHEDULED_CONSULTATION_REPORT: 'write-scheduled-consultation-report',
  NOTIFICATION_CENTER: 'notification-center',
  VITAL_DATA: 'vital-data',
  VITAL_DATA_SETTINGS: 'vital-data-settings',
  HOSPITAL_ADMIN: 'hospital-admin',
  HOSPITAL_ADMIN_REDIRECT: 'hospital-admin-redirect',
  ADMIN_HOSPITALS: 'admin-hospitals',
  ADMIN_USERS: 'admin-users',
  ADMIN_PATIENTS: 'admin-patients',
  ADMIN_SETTINGS: 'admin-settings',
  ADMIN_ROUTING: 'admin-routing',
  ADMIN_ROUTING_CHANGE_LOG: 'admin-routing-change-log',
  ADMIN_CONSULTATIONS_TRACKING: 'admin-consultations-tracking',
  ADMIN_SETTINGS_ROUTING: 'admin-settings-routing',
  ADMIN_SETTINGS_VITAL_DATA: 'admin-vital-data-settings',
  ADMIN_SETTINGS_ACCOUNT: 'admin-account',
  ADMIN_SETTINGS_REPORTING_FORMS: 'admin-reporting-forms',
  ADMIN_SETTINGS_COLOR_SCHEME: 'admin-color-scheme',
  ADMIN_SETTINGS_LINKED_HOSPITALS: 'admin-linked-hospitals',
  ADMIN_SETTINGS_ROUTING_LOG: 'routing-log',
  ADMIN_SETTINGS_ROUTING_LOG_TABLE: 'routing-log-table',
  ADMIN_SETTINGS_ROUTING_LOG_DETAILS: 'routing-log-details',
  PLUGIN_NOT_LICENSED: 'plugin-not-licensed'
} as const

export type routeNames = (typeof routeNames)[keyof typeof routeNames]
